<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gUe0WK/tc-custom/9781427862983.jpg?1729082774010" alt="This image is the cover for the book Dogby Walks Alone, Volume 2, Dogby Walks Alone"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dogby Walks Alone, Volume 2, Dogby Walks Alone
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A theme park mascot’s adventures continue as he tries to save a small town overrun by a strange cult in this humorous mystery manga.</b></p><p> After the harrowing incident at Happyplace, Dogby, battered and alone, heads up north. Collapsing from the cold and exhaustion, he’s brought in by a single mother and her son in desperate need of a father figure. However, things aren’t exactly normal in this town, which is being taken over by a cult. If Dogby’s going to take on legions of disciples, he might have to call in for some extra help, straight from Hollywood. </p><p><b>Praise for <i>Dogby Walks Alone, Vol. 1</i></b></p><b>“[Abbott] has a pedigree, solid chops on almost every aspect of producing a comic book, and has now produced one of the best OEL manga to come out this year in <i>Dogby Walks Alone</i>. . . . I'd love to let you in on some of the jokes that had me laughing out loud, but you're better off finding them on your own.” —IGN.com</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Wes Abbott
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tokyopop Verlag
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2d61e103